import { Component, Input, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { ListGroupSelectableItem } from '../../../dto';

@Component({
    selector: 'app-si-list-group-selectable',
    templateUrl: './si-list-group-selectable.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SiListGroupSelectableComponent {
    public selectedItem: ListGroupSelectableItem;
    @Output() selectedIxChange = new EventEmitter();
    @Input() choices: Array<ListGroupSelectableItem> = [];
    @Input()
    get selectedIx() {
        return this.selectedItem;
    }

    set selectedIx(choice: ListGroupSelectableItem) {
        this.selectedItem = choice;
    }

    selectedIndex = 0;

    makeSelection(choice: ListGroupSelectableItem): void {
        this.selectedIx = choice;
        this.selectedIxChange.emit(this.selectedItem);
    }

}
